import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {article10DayPerformance_template} from "../components/templates/article10DayPerformance_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;

export class article_10_day_performance extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: article10DayPerformance_template;
    protected pagination: pagination_template;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected timer;

    protected getModuleName(){

        return "article_performance";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.elementsList = new article10DayPerformance_template("list", this.viewModel, this);
        this.template = this.elementsList;

        let vnApp = this.getVnAppZone().app;
        let roles = vnApp.loggedUser.user.valnet_user.roles;
        for(let r of roles ){
            //if Job is websiteManager(2) or Admin(1)
            if(r.id == 4 ||r.id == 6){
                this.elementsList.setUser(vnApp.loggedUser.user);
            }
        }

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Article Leaderboard");

        return [this.elementsList.build()];
    }

    public fillPage() : void{

        this.updateViewModelFromPath();
        this.getSearchPresetsListData();

        this.filterList();
    }

    protected onClickShowRecentArticleStats() {

        this.filterList();
    }

    protected onClickShowOwnArticleStats(){

        this.filterList();
    }

    // protected filterSimpleOnChange(){
    //
    //     this.filterList();
    // }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    // protected filterMultipleSelectorOnChange(){
    //
    //     this.filterList();
    // }

    protected getUsersSuggestion(keyword) {

        let subViewModel = {list: {keyword: keyword}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/user/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data) {
                    obj.elementsList.filterUser.getTemplateViewModel().users(responseParsed.data.users);
                }

            });
        }

    }

    protected filterList(){

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));


        let usrReq_url: string = '/api/brand/'+ this.getVnAppZone().app.params.idBrand + '/article10DayPerformance/get/';

        let subViewModel = this.elementsList.getViewModelForRequest();
        this.timer = new Date().getTime();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'article_10_day_performance');
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateList(responseParsed);
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            });
        }
    }

    // update the module list using the objects list
    protected updateList(responseParsed: any){

        // set articles list
        let articlesToSet = [];
        for (let item of responseParsed.data) {

            articlesToSet.push( {
                idPS: item.idPS
                ,title: item.title
                ,name: item.name
                ,date : item.date ? item.date.substring(0,10) : null
                ,contentType: item.contentType
                ,networkCategory: item.networkCategory
                ,id : item.idArticle
                ,global_tier: item.global_tier
                ,secondary_tier: item.secondary_tier
            } )
        }

        this.elementsList.setStats(articlesToSet);
        this.elementsList.setUserFilterEnable(responseParsed.userFilterEnable);


        //set content type filter
        // this.elementsList.setContentType(responseParsed.contentTypes);

        // //set network category status
       // this.elementsList.setNetworkCategory(responseParsed.networkCategories);

        //group_ContentTypes
        this.elementsList.setGroupContentTypeFilterItems(responseParsed.groupContentTypes);

        //group_Category
        this.elementsList.setGroupCategoryFilterItems(responseParsed.groupCategory);

        let execTime = Math.round((new Date().getTime() - this.timer)/1000*100)/100;
        this.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPages,execTime );

        //Update the Paginator
        this.viewModel.list.pagination.itemCount(responseParsed.totalCount);
    }

    protected paginationOnPageClick(){

        this.filterList();
    }



    protected filterMultipleSelectorOnChange(){
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDropdownOnChange(){
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.filterList();
    }

    protected articlesListReorder(){

        this.filterList();
    }

    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdl ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.elementsList.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onPostSearchPresetArticles
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onPostSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.elementsList.addCreatedPresetToList(response);
            });

        }
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void {

        if( "saveFavoriteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onPostFavoriteSearchPresetArticles
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onPostFavoriteSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
            });
        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if( "deleteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        let usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
            });
        }
    }

    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.elementsList.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.elementsList.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    protected setDefaultStatusFilters(){
        //Do nothing
    }

    protected filterByUrl(){
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterByPresets(filters){
        this.elementsList.setViewModelFromRequest(filters);
        this.filterList();
    }

}


// WEBPACK FOOTER //
// ./js/modules/article_10_day_performance.ts